import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import {
  FiAward,
  FiBookOpen,
  FiHome,
  FiLogOut,
  FiMessageSquare,
  FiTarget,
  FiUser,
} from "react-icons/fi";

const navItems = [
  { label: "Home", icon: <FiHome className="w-4 h-4" />, path: "/participant/dashboard" },
  {
    label: "Learning Path & Courses",
    icon: <FiBookOpen className="w-4 h-4" />,
    path: "/participant/courses-and-learning-path",
  },
  {
    label: "Feedback & Support",
    icon: <FiMessageSquare className="w-4 h-4" />,
    path: "/participant/feedback-and-support",
  },
  { label: "Achievement", icon: <FiAward className="w-4 h-4" />, path: "/participant/achievements" },
  { label: "Profile", icon: <FiUser className="w-4 h-4" />, path: "/participant/profile" },
];

const ParticipantSidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { logout } = useAuth();

  const handleNavClick = () => {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      onClose?.();
    }
  };

  return (
    <>
      {isOpen && (
        <button
          type="button"
          className="fixed inset-0 bg-black/30 z-20 md:hidden"
          onClick={onClose}
          aria-label="Close sidebar overlay"
        />
      )}

      <aside
        className={`fixed md:static top-0 left-0 bottom-0 z-30 md:z-0 bg-white border-r border-gray-100 shadow-md transition-all duration-300 flex flex-col justify-between ${
          isOpen ? "w-[75%] md:w-[310px] opacity-100" : "w-0 opacity-0 md:opacity-100 md:w-0 overflow-hidden"
        }`}
      >
        <div className="px-4 py-8 w-full flex flex-col gap-3">
          {navItems.map((item) => {
            const active = location.pathname.includes(item.path);

            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={handleNavClick}
                className={`w-full flex items-center justify-start gap-2 font-medium text-xs px-4 py-3 rounded-md transition-colors ${
                  active ? "bg-[#0A3059] text-white" : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                {item.icon}
                <span className="text-xs">{item.label}</span>
              </Link>
            );
          })}
        </div>

        <div className="px-4 pb-5 w-full">
          <button
            type="button"
            onClick={logout}
            className="w-full bg-gray-100 text-[#0A3059] hover:bg-gray-200 flex items-center justify-start gap-2 font-medium text-xs px-4 py-[15px] rounded-md"
          >
            <FiLogOut className="w-4 h-4" />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default ParticipantSidebar;
